import { Component } from '@angular/core';

@Component({
  selector: 'app-ats-resume-section',
  templateUrl: './ats-resume-section.component.html',
  styleUrls: ['./ats-resume-section.component.css'],
})
export class AtsResumeSectionComponent {}
